import { LogOutIcon, SettingsIcon, UserIcon } from 'lucide-react';

import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ROUTE_LOGIN } from '@/common/constants';
import { useTranslation } from 'react-i18next';
import { clearBearerToken } from '@/common/axios';
import { IUser } from '@/common/models';

export function NavUser({ user }: { user: IUser | null }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const logout = () => {
    clearBearerToken();
    navigate(ROUTE_LOGIN);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="lg" variant="ghost">
          <Avatar className="h-9 w-9 rounded-[50%] grayscale">
            {/*<AvatarImage src={user.avatar} alt={user.name}/>*/}
            <AvatarFallback className="rounded-lg">
              {' '}
              {(user?.first_name || '').charAt(0) +
                (user?.last_name || '').charAt(0)}
            </AvatarFallback>
          </Avatar>
          <div className="grid flex-1 text-left leading-tight ">
            <span className="truncate text-sm font-medium text-white">
              {(user?.first_name || '') + ' ' + (user?.last_name || '')}
            </span>
            <span className="truncate text-xs font-normal text-purple-200 ">
              {user?.username}
            </span>
          </div>
          {/*<ChevronDown color='white'/>*/}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
        side={'bottom'}
        align="end"
        sideOffset={4}
      >
        <DropdownMenuLabel className="p-0 font-normal">
          <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
            <Avatar className="h-9 w-9 rounded-[50%]">
              {/*<AvatarImage src={user.avatar} alt={user.name}/>*/}
              <AvatarFallback className="rounded-lg">
                <span className="truncate text-base font-medium">
                  {(user?.first_name || '').charAt(0) +
                    (user?.last_name || '').charAt(0)}
                </span>
              </AvatarFallback>
            </Avatar>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate text-sm font-medium">
                {(user?.first_name || '') + ' ' + (user?.last_name || '')}
              </span>
              <span className="truncate text-xs text-muted-foreground">
                {user?.username || ''}
              </span>
            </div>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={logout}>
          <LogOutIcon />
          <span className="truncate text-sm font-medium">{t('output')}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
